// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"bottom__wrap--kFKmQ"};